import {InitApp} from './core/actions/init/InitApp';
import {LoadApp} from './core/actions/init/LoadApp';
import {StartApp} from './core/actions/init/StartApp';

const _start = app => {
    InitApp(app)
        .then(LoadApp)
        .then(StartApp)
        .catch((err) => {
            console.log(err);
            document.body.dataset.status = 'fatal';
        });
};

const App = el => {
    const app = {
        el: el
    };

    app.start = () => {
        _start(app);
    };

    return app;
};

export {App};
export default App;
